import { IconType } from "../../../common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { Button, type ButtonProps } from "~/common/components/Button/Button";
import { SideButton } from "~/common/components/Button/SideButton";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

type AddToCartButtonProps = {
  sideButton?: boolean;
  actionVariant?: "cart" | "quote" | "salesman";
} & Omit<ButtonProps, "children">;
export const AddToCartButtonBase = (props: AddToCartButtonProps) => {
  const { t } = useTranslation();
  const { actionVariant = "cart", sideButton, ...rest } = props;

  let icon;
  let label;
  if (actionVariant === "cart") {
    icon = IconType.Cart;
    label = t("addToCartPopup.add.submitBtn");
  } else if (actionVariant === "quote") {
    icon = IconType.FileList;
    label = t("cartPage.btn.quote");
  } else {
    icon = IconType.Cart;
    label = t("basket.addToQuote");
  }

  if (sideButton) {
    return <SideButton icon={icon} data-test-id={"btn-add-to-wishlist"} {...rest} />;
  }

  return (
    <Button fullWidth={true} startIcon={<DefaultButtonIcon type={icon} />} data-test-id={"btn-add-to-cart"} {...rest}>
      {label}
    </Button>
  );
};
